<div class="modal-title has-text-left">
    <p class="title is-spaced is-size-3 main-title">Reprise mobile</p>
</div>
<div class="has-text-left">
    <p class="subtitle has-text-tertiary is-size-6">Indiquez l'état de votre {{ selectedPhone.nom }}.</p>
    <div class="question-list">
        @for (configurator of configurators; track configurator) {
            <div>
                <div class="columns is-fullwidth">
                    <div class="column column-question has-text-left is-flex is-vcentered">
                        <p class="text is-level-2 has-text-weight-bold is-flex is-marginless is-inline">
                            <span>{{ configurator.libelle }}</span>
                        </p>
                        <div tabindex="0" class="popover recovery-trigerred-popover is-popover-left">
                            <span tabindex="0" class="icon is-small icon-info force-sticker-height popover-trigger">
                                <i class="tri-infos-circle"></i>
                            </span>
                            <div class="popover-content">
                                @for (description of configurator.descriptionSelected; track description) {
                                    <p class="text is-level-3 has-text-white" [innerHTML]="description"></p>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="column is-narrow">
                        <div class="buttons is-block buttons-with-icon">
                            <trg-options
                                class="pqd-inline-options"
                                [options]="configurator.options"
                                [checkedValue]="configurator.optionSelected"
                                [noCheckedValue]="configurator.optionSelected ? false : true"
                                (onSelectOption)="selectConfigurator(configurator, $event)"
                            ></trg-options>
                        </div>
                    </div>
                </div>
                <div class="is-divider"></div>
            </div>
        }
    </div>
    <div class="is-flex listing-actions">
        <span class="icon-and-text text is-level-2">
            <span class="icon is-small">
                <i class="tri-arrow-left"></i>
            </span>
            <a class="has-text-weight-bold has-text-tertiary" (click)="previous()">Retour</a>
        </span>
        <trg-button primary (click)="next()" [disabled]="formIncomplete" [loading]="isLoading">
            Continuer la reprise
        </trg-button>
    </div>
</div>
